<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import videoService from '@/services/videoService';
import type { VideoResponse } from '@/types/api';

const { t, locale } = useI18n();
const video = ref<VideoResponse | null>(null);

const loadVideo = async () => {
  try {
    const lang = locale.value?.slice(0, 2) || 'fr';
    video.value = await videoService.getVideo(lang);
  } catch {
    video.value = null;
  }
};

onMounted(loadVideo);

// watch(
//   () => locale.value,
//   () => {
//     loadVideo();
//   }
// );

const formattedDate = computed(() => {
  if (!video.value?.publishedDate) return '';
  const d = new Date(video.value.publishedDate);
  return d.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
});
</script>

<template>
  <cs-widget
    v-if="video"
    class="widget-video"
    :title="t('dashboard.VideoTitle')"
  >
    <div class="video-content">
      <div class="video">
        <iframe
          width="50%"
          height="40%"
          :src="video.link"
          :title="video.title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <details class="visually-hidden">
          <summary>{{ video.title }}</summary>
          <p>{{ video.description }}</p>
        </details>
      </div>
      <p v-if="formattedDate" class="video-date">{{ formattedDate }}</p>
      <p v-if="video.description" class="video-description">
        {{ video.description }}
      </p>
    </div>
  </cs-widget>
</template>

<style scoped>
.widget-video {
  height: 17rem;
  overflow: hidden;
  margin: 0;
}
@media screen and (min-width: 1700px) and (max-width: 1900px) {
  .widget-video {
    height: 17.5rem !important;
  }
}
@media screen and (min-width: 1910px) and (max-width: 2100px) {
  .widget-video {
    height: 19.5rem !important;
  }
}

@media screen and (min-width: 2101px) {
  .widget-video {
    height: 23rem !important;
  }
}
.video {
  display: flex;
  justify-items: center;
  justify-content: center;
}
.video-content {
  display: flex;
  min-height: 80%;
  justify-content: space-between;
  flex-direction: column;
  margin: 0;
}

.video-date {
  font-size: 12px;
  color: #595959;
  margin: 0.25rem !important;
}

.video-description {
  font-size: 0.75rem;
  margin: 0;
}

@media screen and (min-width: 1910px) and (max-width: 2100px) {
  .card {
    height: 16rem;
  }
  .video-description {
    font-size: 0.8rem;
  }
  .video-content {
    padding: 1rem;
  }
  .video-date {
    font-size: 0.75rem;
  }
}

@media screen and (min-width: 2101px) {
  .card {
    height: 16rem;
  }
  .video-description {
    font-size: 1rem;
  }
  .video-content {
    padding: 1.5rem;
  }
  .video-date {
    font-size: 1rem;
  }
}
</style>
<style>
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
